import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Content } from '@haleo-frontend/data-access/models';
import { EnvironmentUtils } from '@haleo-frontend/utils';

@Injectable({
    providedIn: 'root'
})
export class ContentService {

    constructor(private http: HttpClient) {
    }

    getContent(programUuid: string, phaseUuid: string, moduleUuid: string, contentUuid: string): Observable<Content> {
        return this.http.get<Content>(EnvironmentUtils.env.api + `contents/${contentUuid}`);
    }

    setContentProgression(contentUuid: string, progression: number): Observable<Content> {

        const data = {
            op: 'replace',
            path: '/progression',
            value: progression
        };
        return this.http.put<Content>(EnvironmentUtils.env.api + `contents/${contentUuid}`, data);
    }
}
